import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ApprovalDataErrorMessage } from '../sidebar/ApprovalDataErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LazyOrderedApprovalStepsBuilder = Loadable({
  loader: () => import( /* webpackChunkName: "OrderedApprovalStepsBuilder" */'./OrderedApprovalStepsBuilder').then(m => ({
    default: m.OrderedApprovalStepsBuilder
  })),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered",
    size: "small"
  }),
  ErrorComponent: ApprovalDataErrorMessage
});